module.exports = __webpack_public_path__ + "static/media/home_work.a1922d86.svg";